"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppointmentSchema = exports.OAppointment = exports.IAppointment = exports.INewAppointment = exports.IAppointmentFilter = void 0;
const moment_1 = __importDefault(require("moment"));
const mongoose_1 = __importDefault(require("mongoose"));
const runtypes_1 = require("runtypes");
const misc_1 = require("./misc");
exports.IAppointmentFilter = (0, runtypes_1.Record)({
    consultant: (0, runtypes_1.Optional)(runtypes_1.String),
    email: (0, runtypes_1.Optional)(runtypes_1.String),
    rejected: (0, runtypes_1.Optional)(misc_1.BooleanString),
    scheduled: (0, runtypes_1.Optional)(misc_1.BooleanString),
});
exports.INewAppointment = (0, runtypes_1.Record)({
    consultant: runtypes_1.String.withConstraint((val) => val.length === 24 || "invalid consultant"),
    firstName: runtypes_1.String.withConstraint((val) => val.length > 0 || "invalid first name"),
    lastName: runtypes_1.String.withConstraint((val) => val.length > 0 || "invalid last name"),
    title: runtypes_1.String.withConstraint((val) => val.length > 0 || "invalid title"),
    organization: runtypes_1.String.withConstraint((val) => val.length > 0 || "invalid organization"),
    email: misc_1.Email,
    phone: runtypes_1.String.withConstraint((val) => val.length > 0 || "invalid phone number"),
});
exports.IAppointment = exports.INewAppointment.extend({
    date: runtypes_1.String.withConstraint((val) => (0, moment_1.default)(val, true).isValid()),
    rejected: runtypes_1.Boolean,
    scheduled: runtypes_1.Boolean,
});
exports.OAppointment = exports.IAppointment.extend({
    id: misc_1.ID,
});
exports.AppointmentSchema = new mongoose_1.default.Schema({
    consultant: { type: mongoose_1.default.Schema.Types.ObjectId, ref: "Consultant" },
    firstName: { type: String, required: true },
    lastName: { type: String, required: true },
    title: { type: String, required: true },
    organization: { type: String, required: true },
    email: { type: String, required: true },
    phone: { type: String, required: true },
    date: { type: Date, default: Date.now(), required: true },
    scheduled: { type: Boolean, default: false, required: true },
    rejected: { type: Boolean, default: false, required: true },
});
